import httpService from '../../../../services/http-service';
import { HttpClientInstance } from '../../../../services/http-service/http-service-configurator';
import { ChannelNameApiCall } from '../../types';
import { FILE_EXTENSION } from '../../const';

export const downloadFile = async (data: any, fileName: string) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
};

export const downloadTemplateFile = async (
  apiUrl: string,
  fileName: string,
  params?: Record<string, any>,
  httpReqService: HttpClientInstance = httpService
) => {
  const { data } = await httpReqService.download(apiUrl, params);
  downloadFile(data, fileName);
};

export const createIsolatedReportApiCall = <ParamsT, FormatT = FILE_EXTENSION, >(
  apiUrl: string,
  format: FormatT,
  httpReqService: HttpClientInstance = httpService): ChannelNameApiCall<ParamsT> => {

  const channelApi: ChannelNameApiCall<{ report_url: string }> = async ({ params, abortSignal }) => {
    const { data } = await httpService.post(`/api/v3/reports/general_reports/schedule_report_generation.${format}`, params, abortSignal);
    return data;
  };

  return async ({ params, abortSignal }) => {
    const { data } = await httpReqService.post<ParamsT, { report_url: string }>(apiUrl, params, abortSignal);
    return channelApi({ params: data, abortSignal });
  };
};

export const createIsolatedImportApiCall = <FormDataT extends FormData>(
  apiUrl: string,
  apiCallParams?: Record<string, any>,
  httpReqService: HttpClientInstance = httpService
): ChannelNameApiCall<FormDataT> => {

  const channelApi: ChannelNameApiCall<FormDataT> = async ({ params, abortSignal }) => {
    const { data } = await httpService.post('/api/v3/imports/external_imports/schedule_import', params, abortSignal);
    return data;
  };

  return async ({ params, abortSignal }) => {
    const { data } = await httpReqService.get<Record<string, any>, { import_url: string; supported_columns?: string[];[key: string]: any }>(apiUrl, apiCallParams, abortSignal);

    if (data && typeof data === 'object') {
      Object.keys(data).forEach(key => {
        if (Array.isArray(data[key])) {
          params.append(key, JSON.stringify(data[key]));
        } else {
          params.append(key, data[key]);
        }
      });
    }
    return channelApi({ params, abortSignal });
  };
};